import { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../i18n";
import styles from "./CopyButton.module.css";

export function CopyButton({ value, label }: { value: string; label: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    } catch {
      // clipboard unavailable in this environment; nothing to recover
    }
  }

  return (
    <button type="button" className={styles.copyBtn} onClick={() => void handleCopy()} aria-label={label}>
      {copied ? t("companies.copyButton.copied", "Copied") : t("companies.copyButton.copy", "Copy")}
    </button>
  );
}
